import type { Feedback, FeedbackService } from '../feedback-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackApi } from '@/infrastructure/api-functions/core-drafting-api/feedback-api';

@injectable()
export class FeedbackServiceImpl implements FeedbackService {
    constructor(
        @inject(FeedbackApi)
        private _feedbackApi: FeedbackApi,
    ) {}

    save(feedback: Feedback): Promise<void> {
        return this._feedbackApi.postFeedback({
            comment: feedback.comment,
            page_params: feedback.taskId,
            type: feedback.type,
        });
    }
}
